import { useEffect } from 'react';
import HeroSection from './components/HeroSection';
import HotVideos from './components/HotVideos';
import CreatorShowcase from './components/CreatorShowcase';
import CategoryBrowse from './components/CategoryBrowse';
import LatestContent from './components/LatestContent';
import DownloadCTA from './components/DownloadCTA';

export default function Home() {
  useEffect(() => {
    const handleScroll = () => {
      const navbar = document.getElementById('navbar');
      if (!navbar) return;
      if (window.scrollY > 60) {
        navbar.classList.add('bg-background-50/95', 'backdrop-blur-md');
        navbar.classList.remove('bg-transparent');
      } else {
        navbar.classList.remove('bg-background-50/95', 'backdrop-blur-md');
        navbar.classList.add('bg-transparent');
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <main>
      <HeroSection />
      <HotVideos />
      <CreatorShowcase />
      <CategoryBrowse />
      <LatestContent />
      <DownloadCTA />
    </main>
  );
}